import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_6hbq65r7cs: FaireBrandEntity = {
  token: "b_6hbq65r7cs",
  type: "brand",
  name: "Thrival Labs",
  avatarUrl:
    "https://cdn.faire.com/fastly/4e8f3eb9e21255fd67b04ec2c3d644ca9e0e8d638b0bc41c20b6f47c44832176.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/3ed10697ca4d6f0697c63193388c5cd353ccc8f9dd505db0b6b230d0b382e479.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/4e8f3eb9e21255fd67b04ec2c3d644ca9e0e8d638b0bc41c20b6f47c44832176.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/3ed10697ca4d6f0697c63193388c5cd353ccc8f9dd505db0b6b230d0b382e479.jpeg",
  location: "Anthem, AZ, USA",
  minimumOrderDollars: 208,
  rating: 5,
  reviewCount: 1,
  isInsider: true,
  description:
    "Thrival Labs offers premium US-manufactured health and beauty products that actually work at competitive prices that you can afford. Our elite manufacturing utilizes premium ingredients and optimized formulations, and is conducted in small, controlled batches for maximum results and weekly freshness. All our products are offered with a 100% satisfaction guarantee.",
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:51:57.865Z",
    importedBy: "entity-db-cli",
  },
};
